import React, { useCallback, useEffect } from 'react';
import { useAnimation } from 'framer-motion';
import useLoginEndpoint from '../../hooks/useLoginEndpoint/useLoginEndpoint';
import useSceneNavigator, { SceneRoutes } from '../../hooks/useSceneNavigator/useSceneNavigator';
import { useAuthContext } from '../../hooks/useAuth/useAuthContext';

const useLoginSceneModel = () => {
  const controls = useAnimation();

  const { navigate } = useSceneNavigator();

  const [input, setInput] = React.useState<string>('');

  const [waiting, setWaiting] = React.useState<boolean>(false);

  const { setIsAuthenticated } = useAuthContext();

  const {
    userCode, isUserCodeValid, setUserCode, statusCode,
  } = useLoginEndpoint('', () => setWaiting(false));

  useEffect(() => {
    if (waiting) return;
    if (userCode === '' || isUserCodeValid) return;
    // eslint-disable-next-line no-void
    void controls.start('start');
  }, [waiting, userCode, isUserCodeValid, controls]);

  useEffect(() => {
    setIsAuthenticated(isUserCodeValid);
    if (!isUserCodeValid) return;
    navigate(SceneRoutes.UploadScene);
  }, [isUserCodeValid, navigate, setIsAuthenticated]);

  const onVerify = useCallback(() => {
    if (input === '') {
      // eslint-disable-next-line no-void
      void controls.start('start');

      return;
    }
    setWaiting(true);
    setUserCode(input);
  }, [input, controls, setUserCode]);

  return {
    controls,
    input,
    isUserCodeValid,
    onVerify,
    setInput,
    setUserCode,
    statusCode,
    waiting,
  };
};

export default useLoginSceneModel;
